import { useState } from 'react';
import { Card } from '../../../components/layout/card/Card';
import { Button } from '@progress/kendo-react-buttons';
import { useNavigate } from 'react-router';
import pilotageApiRepository from '../../../repositories/api/PilotageApiRepository';
import Overlay from 'components/layout/overlay/Overlay';
import { createPilotPilotageDetailsUrl } from '../../../components/helpers/CreateUrlHelpers';
import { useSuccessNotification, useWarningNotification } from 'components/hooks/useAppStore';

export default function AspiringPilotDetail({ pilotageId }) {
    const navigate = useNavigate();

    const [isBusy, setIsBusy] = useState(false);
    const [hasErrors, setHasErrors] = useState(false);

    const addSuccessNotification = useSuccessNotification();
    const addWarningNotification = useWarningNotification();

    const handleSelfAssignPilotage = async () => {
        setIsBusy(true);
        var response = await pilotageApiRepository.createSelfAssignedPilotage(pilotageId);
        if (response.ok === true) {
            addSuccessNotification(`Tildelt som tentativ på oppdraget.`);
            navigate(createPilotPilotageDetailsUrl(pilotageId));
        } else {
            var errorMessage = await response.text();
            addWarningNotification(errorMessage);
        }
        setIsBusy(false);
    };

    function onReloadClick() {
        setIsBusy(false);
        setHasErrors(false);
    }

    return (
        <>
            <Card title={"Tildel aspirantopplæring"}>
                <p>Sett deg selv som tentativ på oppdraget.</p>
                <Button
                    themeColor="primary"
                    onClick={() => {
                        handleSelfAssignPilotage()
                    }}>
                    Sett som tentativ
                </Button>

            </Card>

            <Overlay isBusy={isBusy} hasErrors={hasErrors} onReloadClick={onReloadClick} />
        </>
    )
}
